export default "/images/vendor/flag-icon-css/flags/4x3/cw.svg?f65c0891df42c24b23dc7e647b1e1afe";